module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jumbotron single-border"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('hgroup', [_c('h2'), _vm._v("\n                For support, please\n                "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("contact ArrowHead")])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well single-border"
  }, [_c('h4', [_c('router-link', {
    attrs: {
      "to": "/models"
    }
  }, [_vm._v("\n                                Models\n                            ")])], 1), _vm._v(" "), _c('p', [_vm._v("Create, manage and query economic models")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h4', [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_vm._v("\n                                Help\n                            ")])], 1), _vm._v(" "), _c('p', [_vm._v("Platform help pages and videos")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h4', [_c('router-link', {
    attrs: {
      "to": "/convergence/monitor"
    }
  }, [_vm._v("\n                                Convergence\n                            ")])], 1), _vm._v(" "), _c('p', [_vm._v("View the status of converging models")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h4', [_c('router-link', {
    attrs: {
      "to": "/admin"
    }
  }, [_vm._v("\n                                Admin\n                            ")])], 1), _vm._v(" "), _c('p', [_vm._v("Site configuration and settings")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h4', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("\n                                About\n                            ")])], 1), _vm._v(" "), _c('p', [_vm._v("About the ArrowHead Modeling Platform")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h4', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("\n                                Contact\n                            ")])], 1), _vm._v(" "), _c('p', [_vm._v("Contact ArrowHead Economics LLC")]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "well well-sm "
  }, [_c('h4', [_vm._v("\n                    Recent Activity\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "multi-column-ul"
  }, _vm._l((_vm.recentItems), function(item) {
    return _c('li', {
      attrs: {
        "id": "recentItemsLi"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.recentItemClick(item)
        }
      }
    }, [_c('p', [_c('span', {
      staticClass: "fa fa-globe"
    }), _vm._v(" " + _vm._s(item.name) + "\n\n                                ")])])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hgroup', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("ArrowHead Economics LLC")]), _vm._v(" "), _c('h1', [_vm._v("ArrowHead Modeling Platform")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cd00b94c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd00b94c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/home/home.vue.html
// module id = 1130
// module chunks = 0